import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
	fetchFaqList,
	changeCurrentPath,
	resetMainListState,
	resetConsigneeListStateNew
} from '../../actions';


import Header from '../../common/containers/header';
import Progress from '../../common/containers/progress'
import SpNav from '../../common/containers/sp_nav'
import Footer from '../../common/containers/footer';

import ErrorDialog from '../../common/components/dialog/error-dialog';
import ReloadModal from '../../common/components/dialog/reload-dialog';
import LogoutModal from '../../common/components/dialog/logout-dialog';

const styles = theme => ({

});





class Faq extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
			detailData:{},
			detailIndex:null
		}
	}
	/** override methods **/

	UNSAFE_componentWillMount() {
		const {dispatch} = this.props;
		dispatch(fetchFaqList());
		dispatch(resetMainListState());
		dispatch(resetConsigneeListStateNew());
	}

	componentDidMount() {
		const { dispatch, history } = this.props;
		window.scrollTo(0, 0);
		dispatch(changeCurrentPath({ currentPath: history.location.pathname }));
	}

	/** event handlers **/

	
	render() {
		const {classes,settings,history} = this.props;
		const {isFetching, isProcessError, data} = settings;



		return (
			<div id="main_container">
				{(isFetching) &&
				<Progress/>
				}
				<SpNav history={history}/>
				<Header history={history}/>
				<article>
					<section className="title_area">
						<h2>FAQ</h2>
					</section>
					<p className={classes.cautionText}>
						よくある質問とその回答をまとめました
					</p>
					<section id="faq_list">
						{data.length ? data.map((dt,index)=>{

							const details = dt.contents.map((row,index)=>{
								return(
									<div className={"faq_detail_box_wrap"} key={index}>
										<div className={"faq_detail_box"}>
											<div className={"faq_question"}>
												{row.question}
											</div>
											<div className={"faq_answer"}
												 dangerouslySetInnerHTML={{
													 __html:row.answer
												 }}
											/>
										</div>
									</div>
								)
							});
							return(
								<div className={"faq_list_box"} key={index}>
									<h4><span>{dt.title}</span></h4>
									<div className={"faq_detail_wrap"}>
									{details}
									</div>
								</div>
							);
						})
						:
						<p>よくある質問は近日公開いたします。<br/>しばらくお待ち下さい</p>
						}
					</section>
				</article>
				<Footer/>
				<ErrorDialog
					open={isProcessError}
				/>
				<ReloadModal />
				<LogoutModal />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		navigation : state.navigation,
		auth: state.auth,
		settings : state.faqSettings
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(Faq);




// WEBPACK FOOTER //
// ./src/routes/faq/index.js